module.exports = __webpack_public_path__ + "fonts/NetflixSansThin.dcc6d494.ttf";